import { render, staticRenderFns } from "./TestGrouping.vue?vue&type=template&id=05d95768"
import script from "./TestGrouping.vue?vue&type=script&lang=js"
export * from "./TestGrouping.vue?vue&type=script&lang=js"
import style0 from "./TestGrouping.vue?vue&type=style&index=0&id=05d95768&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports